import React, { useState, useEffect } from 'react';

export interface IllegalMoveFormData {
  performance_id: number,
  comment: string,
  entry_number: number,  
}

interface IllegalMoveFormProps {
  isOpen: boolean;
  onSubmit: (data: IllegalMoveFormData) => void;
  onClose: () => void;
  performance_id: number;
  entry_number: number;
  show_comment: string;
}

const IllegalMoveForm: React.FC<IllegalMoveFormProps> = ({ 
  isOpen, 
  onSubmit, 
  onClose, 
  performance_id,
  entry_number,
  show_comment
}) =>{
//console.log(show_comment);
  
const initialIllegalMoveFormData: IllegalMoveFormData = {
    performance_id: performance_id,
    comment: show_comment,
    entry_number: entry_number,
  };

    useEffect(() => {
      setFormState((prevState) => ({
        ...prevState,
        comment: show_comment || '',
      }));
    }, [show_comment]);

  const [formState, setFormState] = useState<IllegalMoveFormData>(
    initialIllegalMoveFormData
  );
  
  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement >
  ): void => {
    const { name, value } = event.target;
    setFormState((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  
  const handleSubmit = (event: React.FormEvent): void => {
    event.preventDefault();
    const userInput = window.prompt("Enter '1234' to confirm:");

    if (userInput === "1234") {
        onSubmit(formState);
        setFormState(initialIllegalMoveFormData);
    } else {
        alert("Submission canceled.");
        setFormState((prevState) => ({
            ...prevState,
            comment: initialIllegalMoveFormData.comment,
        }));
        onClose();
        return;
    }
  };

  if (isOpen) return (
    <div className="pmodal">
        <div className="overlay">
          <div className="modal">
          <form onSubmit={handleSubmit}>
            <p>3 points will be deducted per judges.</p>
            <div className="form-row">
              <label htmlFor="comment">Enter note here</label>
              <textarea name="comment" value={formState.comment} onChange={handleInputChange} required></textarea>
              <input type="hidden" name="performance_id" value={formState.performance_id} onChange={handleInputChange} required />
              <input type="hidden" name="entry_number" value={formState.entry_number} onChange={handleInputChange} required />
            </div>
            <div className="form-row">
              <button className={`p-close-button p_right`} type="submit">Confirm</button>
              <button className={`p-close-button p_left`} onClick={onClose}>Cancel</button>
            </div>
          </form>
            <button className="closeButton" onClick={onClose}>X</button>
          </div>
      </div>
    </div>
  );
  else return ('');
}

export default IllegalMoveForm;